<div (click)="open('/main/farms')"
     [ngClass]="{'pointer pointer-hover': farms.length > 1}"
     class="rounded-2 border-3 border-bottom background-pure-white height-100px p-3">
     @if (farmStore.loading()) {
        <lib-loading-placeholder [show]="true"></lib-loading-placeholder>
     } @else {
        <div>
            <div class=" d-flex justify-content-between">
                <div class=" fs-main fw-bold mb-3">{{ farmStore.farm()?.name || '...' }} @if (hasNFCTags()) {
                  <app-metadata [farm]="farmStore.farm()"/>
                }</div>
                @if (farms.length > 1) {
                    <div class=" mt-auto mb-auto">
                        <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
                    </div>
                }
            </div>
            <div (click)="open('/main/farms')" class="d-flex gap-3 pb-3">
                <app-weather-widget/>
                <app-farm-geometry/>
            </div>
            <div class="mb-2">Last refresh: {{ lastRefresh }}</div>
        </div>
     }
</div>
